import PermissionLevel from '@/assets/js/enum/PermissionLevel';

export const counterpointModesMap = {
  [PermissionLevel.TEAM_LEAD]: 'leadCounterpoints',
  [PermissionLevel.TEAM_MEMBER]: 'teamCounterpoints',
  [PermissionLevel.HOST]: 'hostCounterpoints',
};

export const permissionLevelsMap = Object.entries(counterpointModesMap).reduce((obj, [k, v]) => {
  return {
    ...obj,
    [v]: k,
  };
}, {});

/** Maximum length for Rounds 3+ annotations, root text and outline node text excerpts */
export const excerptMaxChars = 50;
export const rootTextMaxChars = 110;
export const fixedRowHeight = 200;
export const ellipsisText = '...';

export const DEBATE_HOST_NAME_MAX_CHARS = 16;

export const delay = ms => {
  return new Promise(resolve => setTimeout(resolve, ms));
};
